export function formatTemplateModifiedLabel(isoString) {
  if (isoString == null || isoString === '') {
    return '';
  }

  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) {
    return '';
  }

  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}
